import { render } from "./add-edit-skills.vue?vue&type=template&id=640accee"
import script from "./add-edit-skills.vue?vue&type=script&lang=js"
export * from "./add-edit-skills.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MY PROJECTS\\VUE_3\\EXCEL_LIBRARY\\excel-library-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__